const AccessibilityStatement = () => {
    return (
      <main style={{
          maxWidth: "900px",
          margin: "10vh auto",
          padding: "40px 20px",
          fontFamily: "Arial, sans-serif",
          lineHeight: 1.6,
          color: "#ffffff",
        }}
      >

        <h1>Accessibility Statement</h1>

        <p>
          <strong>Last Updated:</strong> 5/7/2026
        </p>

        <p>
          We are committed to making this website accessible and usable for all
          users, including individuals with disabilities.
        </p>

        <h2>Accessibility Efforts</h2>
        <p>
          We aim to improve accessibility by using readable layouts, consistent
          navigation, responsive design practices, and compatibility with modern
          browsers and assistive technologies where reasonably possible.
        </p>

        <h2>Ongoing Improvements</h2>
        <p>
          Accessibility is an ongoing effort, and we continue to review and improve
          the usability and accessibility of this website over time.
        </p>

        <h2>Third-Party Content</h2>
        <p>
          Some third-party tools, integrations, embedded content, or external
          websites linked from this website may not be fully accessible. We are not
          responsible for the accessibility practices of third-party providers.
        </p>

        <h2>Compatibility</h2>
        <p>
          This website is intended to function on current versions of major web
          browsers and commonly used devices. Certain features may behave
          differently depending on browser, device, assistive technology, or system
          configuration.
        </p>

        <h2>Need Assistance?</h2>
        <p>
          If you experience difficulty accessing any part of this website or need
          assistance, please contact us and we will make reasonable efforts to
          assist you.
        </p>

        <p>
          <strong>Nasir Griffin</strong>
          <br />
          nasircrossgriffin@gmail.com
          <br />
          +1 (609) 805-9113
        </p>
      </main>
    );
  };
  
  export default AccessibilityStatement;